import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Dropdown } from 'semantic-ui-react';

import { AppState } from 'services/types';
// @ts-ignore
import { setHideUnusedGroups } from 'services/hideUnusedGroups/actions';
// @ts-ignore
import { selectHideUnusedGroups } from 'services/hideUnusedGroups/selectors';

interface ConnectedProps {
    hideUnusedGroups?: ReturnType<typeof selectHideUnusedGroups>;
}

interface DispatchProps {
    setHideUnusedGroups: typeof setHideUnusedGroups;
}

type Props = ConnectedProps & DispatchProps;

export class HideUnusedGroupsDropdownItemComponent extends React.PureComponent<
    Props
> {
    handleClick = (): void => {
        const { hideUnusedGroups } = this.props;
        this.props.setHideUnusedGroups(!hideUnusedGroups);
    };

    render(): React.ReactElement {
        const { hideUnusedGroups } = this.props;

        return (
            <Dropdown.Item
                text={`${hideUnusedGroups ? 'Show' : 'Hide'} unused groups`}
                onClick={this.handleClick}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    hideUnusedGroups: selectHideUnusedGroups
});

export default connect(mapStateToProps, { setHideUnusedGroups })(
    HideUnusedGroupsDropdownItemComponent
);
